import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesByProductsComponent from './sales-by-products.component';

let salesByProductsModule = angular
  .module('SalesByProducts', [
    uiRouter
  ])
  .component('salesByProducts', SalesByProductsComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesByProducts', {
      url: '/sales-by-products',
      data: {
        authRequired: true,
        permsRequired: ['products-statistics']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'salesByProducts'
        }
      }
    })
  })
  .name;

export default salesByProductsModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-products/sales-by-products.module.js